type Rgba<T extends string = string> =
  T extends `rgba(${infer R}, ${infer G}, ${infer B}, ${infer A})`
    ? `rgba(${R}, ${G}, ${B}, ${A})`
    : never;
const COLOR_MAX_VALUE = 255;
export function convertColorToRgba(color: string, alpha: number = 1): Rgba {
  // 如果是rgba(r, g, b, a)格式
  if (color.startsWith('rgba')) {
    const rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+(?:\.\d+)?)\)$/;
    const match = color.match(rgbaRegex);
    if (match) {
      const r = parseInt(match[1], 10);
      const g = parseInt(match[2], 10);
      const b = parseInt(match[3], 10);
      const a = parseFloat(match[4]);
      return `rgba(${r}, ${g}, ${b}, ${a || alpha})` as Rgba;
    }
  }

  // 如果是rgb(r, g, b)格式
  if (color.startsWith('rgba')) {
    const rgbaRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)$/;
    const match = color.match(rgbaRegex);
    if (match) {
      const r = parseInt(match[1], 10);
      const g = parseInt(match[2], 10);
      const b = parseInt(match[3], 10);
      return `rgba(${r}, ${g}, ${b}, ${alpha})` as Rgba;
    }
  }

  // 如果是'#aabbcc'格式
  if (color.startsWith('#')) {
    const hexRegex = /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/;
    const match = color.match(hexRegex);
    if (match) {
      const r = parseInt(match[1], 16);
      const g = parseInt(match[2], 16);
      const b = parseInt(match[3], 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})` as Rgba;
    }
  }

  // 如果不匹配则抛出错误
  throw new Error(`Invalid color format: ${color}`);
}

export function parseRgbaToArray(color: Rgba): [number, number, number, number] {
  const rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+(?:\.\d+)?)\)$/;
  const match = (color as string).match(rgbaRegex) as RegExpExecArray;

  const r = parseInt(match[1], 10);
  const g = parseInt(match[2], 10);
  const b = parseInt(match[3], 10);
  const a = parseFloat(match[4]);
  return [r, g, b, a];
}

export function colorOnBackground(color: string, alpha?: number, background = '#ffffff') {
  const rgba = convertColorToRgba(color);
  const back = convertColorToRgba(background);
  let [r, g, b, a] = parseRgbaToArray(rgba);
  const [br, bg, bb] = parseRgbaToArray(back);

  a = alpha || a;
  r = Math.min(r * a + br * (1 - a), COLOR_MAX_VALUE);
  g = Math.min(g * a + bg * (1 - a), COLOR_MAX_VALUE);
  b = Math.min(b * a + bb * (1 - a), COLOR_MAX_VALUE);
  return `rgba(${r}, ${g}, ${b}, 1)`;
}
